import { useAtom } from "jotai";
import { authAtom, remindLocationAtom } from "./atoms";
import { Storage } from "../../storage";
import { useCallback, useEffect } from "react";
import User from "../../types/user";
import { userSavedPlacesAtom } from "../saved-places/atoms";
import { useQueryClient } from "@tanstack/react-query";

export function useAuth() {
  const queryClient = useQueryClient();
  const [{ data, error, isLoading, isFetching, refetch }] = useAtom(authAtom);
  const [
    {
      data: savedPlacesData,
      error: savedPlacesError,
      isLoading: savedPlacesLoading,
      isFetching: savedPlacesFetching,
      refetch: savedPlacesRefetch,
    },
  ] = useAtom(userSavedPlacesAtom);

  const [remindLocation, setRemindLocation] = useAtom(remindLocationAtom);

  useEffect(() => {
    if (error) {
      console.log("error", error);
      logout();
    }
  }, [error]);

  const isLoggedIn = !!data;

  // const logout = () => {
  //   Storage.delete("currentUser");
  //   refetch();
  // };

  const logout = useCallback(async () => {
    Storage.delete("currentUser");
    queryClient.clear();
    setTimeout(() => {
      refetch();
    }, 300);
  }, [refetch, data?.accessToken]);

  return {
    isLoggedIn,
    user: data as User,
    error,
    isLoading,
    isFetching,
    logout,
    remindLocation,
    setRemindLocation,
    isMapper:
      data?.roles?.isSociabilityMapper || data?.roles?.isSociabilityTeam,
    isDerbyUser: data?.roles?.isDerbyUser,
    savedPlacesData,
    savedPlacesError,
    savedPlacesLoading,
    savedPlacesFetching,
    savedPlacesRefetch,
    savedPlacesIds:
      savedPlacesData?.saved_places?.flatMap((place) =>
        place.saved_place_details.map((detail) => detail.business_id),
      ) || [], // Add Optional Chaining and default value
    isAiAccessUser: data?.roles?.isAiAccessUser,
  };
}
